import {gql} from '@apollo/client';

/*
 * Manual content transformations (platform-analytics-service).
 *
 * These resolvers return plain GraphQL errors — there is no `Error` union to
 * unwrap, so failures arrive in the Apollo `error` object / `onError` hook.
 *
 * One selected language = one n8n execution = one history record. Records that
 * came from the same submission share a `requestId` but each has its own `id`.
 */

export const GET_MANUAL_CONTENT_TRANSFORMATIONS = gql`
  query AdminGetManualContentTransformations(
    $search: String
    $pagination: ManualContentTransformationPaginationInput
  ) {
    adminGetManualContentTransformations(
      search: $search
      pagination: $pagination
    ) {
      data {
        id
        requestId
        title
        content
        sourceUrl
        language
        channels
        status
        executionId
        executionUrl
        error
        createdAt
        updatedAt
      }
      pagination {
        page
        limit
        pages
        total
        hasPrevPage
        hasNextPage
        previous
        next
      }
    }
  }
`;

export const GET_MANUAL_CONTENT_TRANSFORMATION = gql`
  query AdminGetManualContentTransformation($id: ID!) {
    adminGetManualContentTransformation(id: $id) {
      id
      requestId
      title
      content
      sourceUrl
      language
      channels
      status
      executionId
      executionUrl
      error
      createdAt
      updatedAt
    }
  }
`;

/*
 * The deprecated top-level `signalRecordId` / `executionId` / `executionUrl`
 * fields are intentionally not selected — `dispatches` carries one entry per
 * language, which is the only complete view of what was started.
 */
export const TRIGGER_CONTENT_TRANSFORMATION = gql`
  mutation AdminTriggerContentTransformation(
    $input: AdminTriggerContentTransformationInput!
  ) {
    adminTriggerContentTransformation(input: $input) {
      accepted
      status
      message
      requestId
      languages
      channels
      dispatches {
        language
        signalRecordId
        executionId
        executionUrl
      }
    }
  }
`;
